export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'ChargeType';
export const NAME = 'InvoiceChargeType';
export const DUPLICATE_RECORD = '-999';
